import { ReactNode } from "react";
import styled from "styled-components";
import { Action, ActionComponent } from "../../../internalComponents";

const StyledActions = styled.div`
  flex-grow: 0;
  order: 3;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;
`;

const ButtonArea = styled.div`
  display: inline-grid;
  grid-auto-flow: column;
  column-gap: 16px;
  margin-left: 16px;
  button[name="close"] {
    order: 2;
  }
`;

const ActionContainer = styled.div`
  flex-grow: 1;
`;

type ActionsProps = {
  /** Render a link or unstyled button along with the main actions */
  extraAction?: Action;

  children: ReactNode;
};

export const Actions = ({ extraAction, children }: ActionsProps) => {
  return (
    <StyledActions>
      {extraAction && (
        <ActionContainer>
          <ActionComponent action={extraAction} />
        </ActionContainer>
      )}
      <ButtonArea>{children}</ButtonArea>
    </StyledActions>
  );
};
